import { SelectionState } from "@alfresco/adf-extensions";
import { MinimalNodeEntity } from "@alfresco/js-api";
import { Action } from "@ngrx/store";

export enum BoudActionTypes {
    CreateBoud = 'CREATE_BOUD',
    ViewBoud = 'VIEW_BOUD',
    EditBoud = 'EDIT_BOUD',
    ValidateBoud = 'VALIDATE_BOUD',
    GeneratePdfBoud = 'GENERATE_PDF_BOUD',
    PublishBoud = 'PUBLISH_BOUD',
    DeleteBoud = 'DELETE_BOUD'
}

export class CreateBoudAction implements Action {
  readonly type = BoudActionTypes.CreateBoud;

  constructor(public payload?: SelectionState) {}
}

export class ViewBoudAction implements Action {
  readonly type = BoudActionTypes.ViewBoud;

  constructor(public payload?: SelectionState) {}
}

export class EditBoudAction implements Action {
  readonly type = BoudActionTypes.EditBoud;

  constructor(public payload?: SelectionState) {}
}

export class ValidateBoudAction implements Action {
  readonly type = BoudActionTypes.ValidateBoud;

  constructor(public payload?: SelectionState) {}
}

export class GeneratePdfBoudAction implements Action {
  readonly type = BoudActionTypes.GeneratePdfBoud;

  constructor(public payload?: SelectionState) {}
}

export class PublishBoudAction implements Action {
  readonly type = BoudActionTypes.PublishBoud;

  constructor(public payload?: SelectionState) {}
}

export class DeleteBoudAction implements Action {
  readonly type = BoudActionTypes.DeleteBoud;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}